import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import api from '@/services/api'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      refreshToken: null,
      user: null,
      _hasHydrated: false,

      setHasHydrated: (value) => set({ _hasHydrated: value }),

      login: async (username, password) => {
        const resp = await api.post('/auth/token/', { username, password })
        const { access, refresh, user } = resp.data
        set({ token: access, refreshToken: refresh, user })
        api.defaults.headers.common['Authorization'] = `Bearer ${access}`
        return user
      },

      logout: () => {
        set({ token: null, refreshToken: null, user: null })
        delete api.defaults.headers.common['Authorization']
      },

      setToken: (access) => {
        set({ token: access })
        api.defaults.headers.common['Authorization'] = `Bearer ${access}`
      },

      fetchMe: async () => {
        const resp = await api.get('/auth/users/me/')
        set({ user: resp.data })
        return resp.data
      },
    }),
    {
      name: 'skud-auth',
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    }
  )
)
